export const COACHMARK_IDENTIFIER = 'COACHMARK_';
export const COACHMARK_SESSION_IDENTIFIER = 'SESSION_COACHMARK';

export const SESSION_CONFIG = {
  MAX_OCCURENCE_IN_SESSION: 2,
  MAX_ELIGIBLE_SESSIONS: 3,
};
